import { createAction, props } from '@ngrx/store';
import { SearchValues } from '@store/app-context/app-context.reducer';

export enum AppContextActions {
  APP_CONTEXT_SET_SEARCH_VALUE = '[APP_CONTEXT] SET_SEARCH_VALUE',
}

export const setSearchValues = createAction(
  AppContextActions.APP_CONTEXT_SET_SEARCH_VALUE,
  props<{ params: SearchValues }>(),
);
